import React from 'react';
import { Button, Glyphicon } from 'react-bootstrap';

class ListFilterBox extends React.Component {
  render() {
    const { InputFilter } = this.props.fuzzyFilterFactory;
    return (
      <div className="filter-box">
        <InputFilter
          inputProps={{
            className: 'form-control',
            placeholder: 'Filter'
          }}
          onChange={this.props.onChange}
        />
        <Button type="submit" className="search"><Glyphicon glyph="search" /></Button>
      </div>
    )
  }
}

export default ListFilterBox;



// WEBPACK FOOTER //
// ./src/components/ListFilterBox.js